import { HeaderOnlyHome } from '@/components/mobile/header-only-home'
import { createFileRoute, redirect, useRouter } from '@tanstack/react-router'
//@ts-expect-error
import terminal from 'virtual:terminal';
import styles from './styles.module.scss'
import { cardsServiceInstance, type GetCardResponse } from '@/services/cards.service'
import { startTransition, useCallback, useEffect, useMemo, useRef, useState, useTransition } from 'react'
import ReactHowler from 'react-howler'
import { AnimatePresence, motion } from 'motion/react'
import { currencyFormat } from '@/utils/currency-format'

import { useAtom } from 'jotai'
import { userAtom } from '@/store/atoms/user.atom'
import { useConfigContext } from '@/contexts/config-context'
import Lottie, { type LottieRefCurrentProps } from 'lottie-react'
import bingo from '../../../assets/bingo.json'
import type { AxiosError } from 'axios';
import { CardDrawStatusLose } from '@/components/ui/card-draw-status-lose';
import toast from 'react-hot-toast';

export const Route = createFileRoute('/mobile/game/')({
  component: RouteComponent,
  loader: async () => {
    try {
      const [card, quantityPendings] = await Promise.all([
        cardsServiceInstance.getFirst(),
        cardsServiceInstance.mePending()
      ])
      if (!card) {
        redirect({
          to: '/mobile/home',
          throw: true,
        })
      }

      return {
        card,
        quantityPendings
      }
    } catch (err) {
      terminal.log(err)
      throw redirect({
        to: '/mobile/home',
        throw: true
      })

    }
  },
  shouldReload: () => true,
  staleTime: 0,
})

const MAX_IMGS_PER_ROW = 10

function makeForView(numbers: number[]) {
  const viewGrid: number[][] = []
  let idx = 0;
  for (const num of numbers) {
    if (viewGrid[idx] && viewGrid[idx].length >= MAX_IMGS_PER_ROW) {
      idx++
      viewGrid[idx] = []
    }
    if (!viewGrid[idx]) viewGrid[idx] = []
    viewGrid[idx].unshift(num)
  }

  return viewGrid
}


const getQuantityOcurrences = (cardBalls: number[], drawBalls: number[]) => {
  if (!cardBalls || !drawBalls) return 0;
  let occurrences = 0;
  const drawSet = new Set(drawBalls);
  const cardSet = new Set(cardBalls);
  for (const number of Array.from(cardSet)) {
    if (drawSet.has(number)) occurrences++;
  }

  return occurrences;
}

// const atomCount = atom(1)

function RouteComponent() {
  const router = useRouter()
  const [currentCard, setCurrentCard] = useState<GetCardResponse | undefined>(undefined)
  const [numbers, setNumbers] = useState<number[]>([])
  const [drawNumbers, setDrawNumbers] = useState<number[]>([])
  const [balls, setBalls] = useState<Array<number>>([])
  const [isDone, setIsdone] = useState(false)
  const [currentUser, setUser] = useAtom(userAtom)
  const rowllerRef = useRef<ReactHowler>(null)
  const backgroundMusic = useRef<ReactHowler>(null)
  const { getAnimationTime, animationVelocity, audioIsEnabled } = useConfigContext()
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [quantityPendingsState, setQuantityPendings] = useState(1)
  const [quantityPendingsCards, setQuantityPendingsCards] = useState(0)

  const quantityOcurrences = currentCard ? getQuantityOcurrences(currentCard?.card?.cardBalls, currentCard?.card?.drawBalls) : 0
  const [updateCardPending, transitionUpdateCard] = useTransition()
  const lottieRef = useRef<LottieRefCurrentProps>(null)

  const viewNumbers = useMemo(() => makeForView(numbers).reverse(), [numbers])


  const loadData = useCallback(async () => {
    const [card, quantityPendings] = await Promise.all([
      cardsServiceInstance.getFirst(),
      cardsServiceInstance.mePending()
    ])

    if (card) {
      setCurrentCard(card)
      setBalls([...card.card.drawBalls])
      setQuantityPendingsCards(quantityPendings)
    }
  }, [])
  const updateCurrentCard = async (id: string) => {
    try {
      await cardsServiceInstance.drawCard(id)
    } catch (err) {
      console.error(err)
      toast.error("Erro ao atualizar cartela.")
    }
  }

  const getNextCard = async () => {
    transitionUpdateCard(async () => {
      try {
        backgroundMusic.current?.howler.stop()
        lottieRef.current?.pause()
        // setCurrentCard(undefined)
        if (currentUser && currentCard && currentCard.card.priceValue > 0) {
          setUser({
            ...currentUser,
            wallet: {
              amount: currentUser.wallet.amount + currentCard.card.priceValue
            }
          })
        }
        const nextCard = await cardsServiceInstance.getToDraw()
        // const quantityCards = await cardsServiceInstance.mePending()
        if (!nextCard) {
          await router.invalidate()
          return
        }
        // setCurrentNumber(prev => prev + 1)
        setBalls([...nextCard.card.drawBalls])
        setCurrentCard(nextCard)
        setDrawNumbers([])
        setNumbers([])
        setQuantityPendings(prev => prev + 1)
        lottieRef.current?.play()
      } catch (err) {
        const errno = err as AxiosError
        toast.error("Erro ao atualizar cartela.")
        if (errno.status === 400) {
          // const pendings = await cardsServiceInstance.mePending()
          if (quantityPendingsCards > quantityPendingsState) {
            const card = await cardsServiceInstance.getToDraw()

            if (!card) {
              await router.invalidate()
              return
            }
            setBalls(card.card.drawBalls)
            setCurrentCard(card)
            // setCurrentNumber(prev => prev + 1)
            setQuantityPendings(prev => prev + 1)
            setDrawNumbers([])
            setNumbers([])

            lottieRef.current?.play()
            backgroundMusic.current?.howler.play()
          } else {
            await router.invalidate()
            router.navigate({ to: '/mobile/home' })
          }
        }
      }
    })
  }
  useEffect(() => {
    loadData()
  }, [])
  useEffect(() => {
    if (!lottieRef.current && !currentCard?.id) return
    let interval: NodeJS.Timeout
    const tid = setTimeout(() => {
      interval = setInterval(async () => {
        startTransition(() => {
          lottieRef.current?.pause()
          rowllerRef.current?.stop()
          const ball = balls ?? []
          const currentNumber = ball.pop()
          if (!currentNumber) {
            return
          }
          setNumbers((prev) => Array.from(new Set([...prev, currentNumber])))
          setDrawNumbers(prev => [...prev, currentNumber])
          setBalls(ball)
          if (ball.length <= 0) {
            setTimeout(() => {
              rowllerRef.current?.howler.pause()
              backgroundMusic.current?.howler.pause()
              setIsdone(true)
              setIsOpenModal(true)
              clearInterval(interval)
            }, 600)
            return
          }
          lottieRef.current?.play()
        })

      }, getAnimationTime(animationVelocity))
    }, 600)

    return () => {
      clearInterval(interval)
      clearTimeout(tid)
    }
  }, [currentCard?.id])

  useEffect(() => {
    if (isDone || isOpenModal) {
      rowllerRef.current?.howler.pause()
    }
  }, [isDone, isOpenModal])
  useEffect(() => {
    if (isDone && currentCard?.id) {
      updateCurrentCard(currentCard?.cardId ?? '')
    }
  }, [isDone, currentCard?.id])
  useEffect(() => {
    console.log(`Counter atualizado: ${quantityPendingsState}`)
  }, [quantityPendingsState])

  const getBallImage = (idx: number) => {
    return `/assets/balls/${idx}.svg`
  }

  return (
    <div className={styles.container}>
      <HeaderOnlyHome withConfig />
      <Lottie
        renderer='svg'
        rendererSettings={{ preserveAspectRatio: 'xMidYMid meet', progressiveLoad: true, }}
        animationData={bingo}
        style={{
          width: 350,
          height: 200,
          margin: '0 auto'
        }}
        lottieRef={lottieRef}
      />
      <div className={styles.content}>
        <div className={styles.counter}>
          <h4>Sorteio {quantityPendingsState} / {quantityPendingsCards}</h4>
        </div>
      </div>

      <div className={styles.balls}>
        <div className={styles.content}>
          <div className={styles.counter}>
            <b>Id: {currentCard?.card.key}</b>
          </div>
        </div>

        <div className={styles.ticket}>
          <div>
            <AnimatePresence mode='wait' initial={false}>
              {
                !updateCardPending && currentCard && currentCard?.card.cardBalls.map((n) => (
                  <div key={n}>

                    {
                      drawNumbers.includes(n) ? (
                        <>
                          <motion.img
                            initial={{ opacity: 0, scale: 0 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{
                              duration: 0.4,
                              scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
                            }}
                            src={getBallImage(n)}
                            data-ball={n}
                          />
                        </>
                      ) : n
                    }
                  </div>
                ))
              }
            </AnimatePresence>
          </div>
        </div>

        {
          isDone && (
            <>
              <div className={styles.score_board}>
                <div>
                  <div>
                    <b>Acertos</b>
                    <b>{quantityOcurrences}</b>
                  </div>
                  <div>
                    <b>Prêmio</b>
                    <b>{currencyFormat(currentCard?.card?.priceValue ?? 0)}</b>
                  </div>
                </div>

                <button
                  disabled={updateCardPending}
                  onClick={async () => {
                    if (!currentCard) return
                    await getNextCard()

                    if (!quantityPendingsState) {
                      router.navigate({ to: '/mobile/home' })
                    }
                    setIsdone(false)
                  }}
                >
                  <img
                    src="/assets/next_draw.png"
                  />
                </button>
              </div>
            </>
          )
        }

        <AnimatePresence
          mode="wait"
          initial={false}
        >
          {
            !updateCardPending && viewNumbers.map((row, idx) => (
              <motion.ul
                key={`row-${idx}`}
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{
                  type: "spring",
                  stiffness: 120,
                  damping: 18,
                  mass: 0.8
                }}
              >
                <AnimatePresence
                  mode="wait"
                  initial={false}
                >
                  {row.map((i) => (
                    <motion.li
                      key={i}
                      layout
                      initial={{ x: -50, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      // exit={{ x: 50, opacity: 0 }}
                      transition={{
                        type: "spring",
                        stiffness: 120,
                        damping: 18,
                        mass: 0.8
                      }}
                    >
                      <motion.img
                        animate={{
                          rotate: [0, 360],
                        }}
                        transition={{
                          duration: 0.4,
                          ease: "linear"
                        }}
                        src={getBallImage(i)}
                      />
                    </motion.li>
                  ))}
                </AnimatePresence>
              </motion.ul>
            ))
          }
        </AnimatePresence>
      </div>

      <ReactHowler
        src="/assets/bingo_effect.mp3"
        playing={true}
        ref={rowllerRef}
        preload
        mute
        onLoad={() => {
          lottieRef.current?.play()
          terminal.log("play lottie")
        }}
      />
      <ReactHowler
        src="/assets/floating.mpeg"
        playing={true}
        preload
        ref={backgroundMusic}
        mute={!audioIsEnabled}
      />
      {
        isDone && currentCard && isOpenModal && (
          <CardDrawStatusLose
            numberOfHits={quantityOcurrences}
            onNextDraw={async () => {
              await getNextCard()
              if (quantityPendingsState >= quantityPendingsCards) {
                router.navigate({ to: '/mobile/home' })
              }
              setIsdone(false)
            }}
            type={currentCard?.card?.priceValue > 0 ? "win" : "lose"}
            value={currentCard?.card?.priceValue}
            onClose={() => {
              setIsOpenModal(false)
            }}
          />
        )
      }
    </div>
  )
}


/*
 
*/